import { useEffect } from 'react';
import { useToastStore } from '@/store/toast';

export function Toast() {
  const messages = useToastStore((s) => s.messages);
  const dismiss = useToastStore((s) => s.dismiss);

  useEffect(() => {
    if (messages.length === 0) return;
    const timers = messages.map((m) => setTimeout(() => dismiss(m.id), 8000));
    return () => timers.forEach(clearTimeout);
  }, [messages, dismiss]);

  if (messages.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 max-w-sm">
      {messages.map((m) => (
        <div
          key={m.id}
          className="bg-surface border border-border rounded-md shadow-lg px-4 py-3 text-sm text-content flex items-start gap-3"
        >
          <span className="flex-1">{m.text}</span>
          <button
            type="button"
            onClick={() => dismiss(m.id)}
            aria-label="Dismiss"
            className="text-content-subtle hover:text-content"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
